Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const LANGCHAIN_INTEGRATION_NAME = 'LangChain';
const LANGCHAIN_ORIGIN = 'auto.ai.langchain';

const ROLE_MAP = {
  human: 'user',
  ai: 'assistant',
  assistant: 'assistant',
  system: 'system',
  function: 'function',
  tool: 'tool',
};

exports.LANGCHAIN_INTEGRATION_NAME = LANGCHAIN_INTEGRATION_NAME;
exports.LANGCHAIN_ORIGIN = LANGCHAIN_ORIGIN;
exports.ROLE_MAP = ROLE_MAP;
//# sourceMappingURL=constants.js.map
